export default "/assets/website/images/divider-line.png?2594ca6c598814545a5435391ba74f1f";